import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${(props) => props.theme.size.static200};
  align-self: stretch;

  @media (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${(props) => props.theme.size.static250};
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    gap: ${(props) => props.theme.size.static300};
  }
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${(props) => props.theme.size.static200};

  @media (min-width: ${Breakpoints.b560}px) {
    gap: ${(props) => props.theme.size.static250};
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    gap: ${(props) => props.theme.size.static300};
  }
`;

export const StyledRowSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.static200};

  @media (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
    gap: ${(props) => props.theme.size.static250};
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    flex-direction: row;
    gap: ${(props) => props.theme.size.static300};
  }
`;
